import { LocaleHelper } from "@bryntum/schedulerpro";

// While locale switching logic is not there, we can just override existing locale like this
LocaleHelper.locales.En.FieldFilterPicker.isOneOf = 'include';
LocaleHelper.locales.En.FieldFilterPicker.isNotOneOf = 'exclude';
